import PostApiCall from "../Helper/PostApi";
import Notiflix from "notiflix";
import logoholexo from "../images/Logo/holexo.png";
import "./Navbar.css";
import React, { Component } from "react";

class Navbar1Web extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: [],
      text: "",
      productCart: [],
      searchText: "",
      loginData: [],
      open: false,
      openmenu: false,
      nav: false,
      MyProfile: false,
      windowWidth: window.innerWidth,
      DefaultPincode: null,
      CartAmount: 0,
      StateId: 0,
      MyAccount: "",
      Name: "",
    };
  }

  // For search bar
  selectedText(value) {
    this.setState(() => ({
      text: value,
      suggestions: [],
      Menubcolorbackaground: "transparent",
    }));
  }
  listenScrollEvent = (e) => {
    if (window.scrollY == 0) {
      this.setState({ Menubcolorbackaground: "transparent" });
    } else {
      this.setState({ Menubcolorbackaground: "black" });
    }
  };
  componentDidMount() {
    window.addEventListener("scroll", this.listenScrollEvent);
    Notiflix.Loading.init({
      svgColor: "#ee1b2f",
    });

    // For User login
    var login = localStorage.getItem("CustomerData");
    var logindetails = JSON.parse(login);

    if (logindetails != null) {
      this.setState({
        loginData: logindetails[0],
        Name: logindetails[0].fld_name,
      });
    }
    if (localStorage.getItem("ChangedPincode") == null) {
      this.setState({
        open: true,
      });
    }

    if (this.state.suggestions.length == 0) {
      PostApiCall.postRequest(
        {
          destinationName: "",
        },
        "Searchdestination"
      ).then((results) =>
        results.json().then((obj1) => {
          if (results.status == 200 || results.status == 201) {
            this.setState({
              suggestions: obj1.data,
            });
          }
        })
      );
    }
  }

  render() {
    window.addEventListener("scroll", this.listenScrollEvent);
    const { text, suggestions } = this.state;
    return (
      <>
        <nav className="main-nav navbarfont">
          <div className="nav-container">
            <div className="nav-item nav-item2">
              <img
                onClick={() => (window.location.href = "/")}
                src={logoholexo}
                alt="holexo"
                style={{ cursor: "pointer", width: "140px", height: "60px" }}
              />
            </div>
            <div className="nav-item nav-item1">
              <div className="mailicon">
                <a
                  href="mailto:varun@holxoholidays.com"
                  className="emailhoverbanner"
                >
                  <i className="fa fa-envelope email-phone p-1"></i>
                  <span className="me-3 avenir_regular">
                    varun@holxoholidays.com
                  </span>
                </a>
                <a href="tel:+91 9810070789" className="emailhoverbanner">
                  <i className="fa fa-phone email-phone p-1"></i>
                  <span className="avenir_regular">+91 98100 70789</span>
                </a>
              </div>
              <div className="mailicon">
                <a
                  href="mailto:mitali@holxoholidays.com"
                  className="emailhoverbanner"
                >
                  <i className="fa fa-envelope email-phone p-1"></i>
                  <span className="me-3 avenir_regular">
                    mitali@holxoholidays.com
                  </span>
                </a>
                <a href="tel:+91 9873998300" className="emailhoverbanner">
                  <i className="fa fa-phone email-phone p-1"></i>
                  <span className="avenir_regular">+91 98739 98300</span>
                </a>
              </div>
            </div>
          </div>
        </nav>
      </>
    );
  }
}
export default Navbar1Web;
